import { useHasAccessRights } from "modules/actions/hooks/useHasAccessRights";
import { PATHS } from "modules/shared/constants/paths";

export const useHasRightForUser = () => {
  const hasRightForDisplayUser = useHasAccessRights(PATHS.USER);
  const hasRightForCreateUser = useHasAccessRights(PATHS.CREATE_USER);
  return hasRightForDisplayUser && hasRightForCreateUser;
};
